import { render, staticRenderFns } from "./CreatePatient.vue?vue&type=template&id=fb4e6e64"
import script from "./CreatePatient.vue?vue&type=script&lang=js"
export * from "./CreatePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports